import { render, staticRenderFns } from "./DocumentNewRevisionFormDialog.vue?vue&type=template&id=39697464&"
import script from "./DocumentNewRevisionFormDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentNewRevisionFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports